import { FILTER_TYPES } from 'components/FilterPod';
import jMoment from 'moment-jalaali';

const DEFAULT_DATE_TYPE_OPTIONS = [
  { value: null, label: 'انتخاب نشده' },
  { value: 'START_DATE', label: 'محدوده‌ زمان شروع' },
  { value: 'EXPIRE_DATE', label: 'محدوده‌ زمان انقضا' },
  { value: 'CREATE_DATE', label: 'محدوده‌ زمان ایجاد' },
  { value: 'TRANSFER_DATE', label: 'تاریخ انتقال اعتبار' },
];
const filters = (currencyText) => [
  {
    title: 'نوع تاریخ',
    label: 'نوع تاریخ',
    keyName: 'dateType',
    id: 1384,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: DEFAULT_DATE_TYPE_OPTIONS,
    },
  },
  {
    title: "محدوده تاریخ",

    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
  },
  {
    title: 'محدوده‌ مبلغ مورد نظر',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'amountRange',
    unit: currencyText,
    id: {
      start: 1670,
      end: 1671,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    // TODO: is the labels true? is it currency?
    title: 'محدوده میزان استفاده شده',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'usedRange',
    unit: currencyText,
    id: {
      start: 1672,
      end: 1673,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },

  {
    title: 'شناسه اعتبار',
    label: 'شناسه اعتبار',
    keyName: 'creditId',
    id: 1666,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'شناسه تخصیص دهنده',
    label: 'شناسه تخصیص دهنده',
    keyName: 'ownerUserId',
    id: 1676,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'براساس وضعیت',
    label: 'براساس وضعیت',
    keyName: 'activeStatus',
    id: 1669,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: '1',
          label: 'فعال',
        },
        {
          value: '0',
          label: 'غیرفعال',
        },
      ],
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'دوره',
    label: 'دوره',
    keyName: 'periodId',
    id: 1684,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [],
    },
  },




];

export default filters;
